import React from 'react';
import { Link } from 'react-router-dom';

const GRADIENTS = [
  'from-purple-600 to-blue-500',
  'from-blue-500 to-cyan-400',
  'from-emerald-500 to-teal-400',
  'from-orange-500 to-red-500',
  'from-pink-500 to-rose-400',
  'from-indigo-500 to-violet-500',
];

const OfferCardsRow = ({ banners }) => {
  if (!banners || banners.length === 0) return null;

  const offersWithDiscount = banners.filter(b => b.discountText);
  if (offersWithDiscount.length === 0) return null;

  return (
    <div className="py-3">
      <div className="flex gap-3 overflow-x-auto scrollbar-hide snap-x snap-mandatory px-4">
        {offersWithDiscount.map((banner, i) => (
          <Link
            key={banner._id || i}
            to={banner.linkUrl || '/user/offers'}
            className="flex-shrink-0 w-[160px] h-[100px] rounded-xl overflow-hidden relative snap-start"
          >
            {/* Background — use real image if available, otherwise gradient */}
            {banner.imageUrl ? (
              <>
                <img
                  src={banner.imageUrl}
                  alt={banner.title || 'Offer'}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-black/10" />
              </>
            ) : (
              <div className={`absolute inset-0 bg-gradient-to-br ${GRADIENTS[i % GRADIENTS.length]}`} />
            )}

            {/* Content overlay */}
            <div className="absolute inset-0 flex flex-col justify-end p-3">
              <p className="text-[15px] font-extrabold text-white leading-tight drop-shadow-sm">
                {banner.discountText}
              </p>
              <p className="text-[10px] text-white/80 font-medium truncate mt-0.5">
                {banner.subtitle || banner.title || 'Shop Now'}
              </p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default OfferCardsRow;
